export class FetchConnectionError extends Error {
  constructor() {
    super('Fail to fetch: Connection error')
  }
}
